export const appLanguages = [
  'en',
  'ru',
  'pl',
  'lt',
  'lv',
  'et',
  'bg',
  'cs',
  'de',
  'sq',
  'bs',
  'hr',
  'da',
  'nl',
  'gb',
  'fi',
  'fr',
  'el',
  'hu',
  'is',
  'it',
  'ka',
  'mk',
  'no',
  'pt',
  'ro',
  'sr',
  'sk',
  'sl',
  'es',
  'sv',
  'tr',
  'uk',
] as const;
export type AppLanguage = (typeof appLanguages)[number];

export const contentLanguages = [
  'be',
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'ga',
  'hr',
  'hu',
  'id',
  'is',
  'it',
  'ja',
  'ka',
  'ko',
  'lt',
  'lv',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv',
  'tk',
  'tr',
  'uk',
  'uz',
] as const;
export type ContentLanguage = (typeof contentLanguages)[number];

export const uppercaseContentLanguages = contentLanguages.map((l) =>
  l.toUpperCase(),
) as [Uppercase<ContentLanguage>, ...Uppercase<ContentLanguage>[]];

export const uppercaseAppLanguages = [...appLanguages]
  .sort()
  .map((l) => l.toUpperCase()) as [
  Uppercase<AppLanguage>,
  ...Uppercase<AppLanguage>[],
];
